const claimNamespace = 'https://www.shipt.com/'

export const customClaims = {
  ONBOARDED: `${claimNamespace}member_onboarded`,
  SHIPT_USER_ID: `${claimNamespace}shipt_user_id`,
} as const

export enum Auth0Scope {
  OPENID = 'openid',
  PROFILE = 'profile',
  EMAIL = 'email',
  IS_CUSTOMER = 'is:Customer',
  MANAGE_ACCOUNT = 'manage:account',
  OFFLINE_ACCESS = 'offline_access',
}
